export default __webpack_public_path__ + "static/media/symptoms.6293ea35.svg";